import EInvoicingConfiguration from "./config.type";
import { BrowserCacheLocation } from "@azure/msal-browser";

export const Configuration: EInvoicingConfiguration = {
    msalConfig: {
        auth: {
            clientId: "36af44e5-21a2-4ba0-b039-b76ef8b6b0e8",
            authority: "https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
            redirectUri: "https://modern.einvoicing-dashboard.cp.microsoft.com", //http://localhost:3000 
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage, // localStorage persists across redirects through CDN/Front Door
        }
    },
    
    // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
    msalTokenRequest: {
        scopes: []
    },

    eventServiceUrl: "https://modern.einvoicing.eventservice.cp.microsoft.com",

    featureFlags: {
        manualInvoices: true,
        columnPicker: true,
        manualInvoiceCreator: true
    }
}
